import axios from "axios";
// import config from "../config.js";

const $http = axios.create();

$http.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
$http.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
$http.defaults.transformRequest = [
  function (data) {
     let ret = ''
     for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
     }
     ret = ret.substring(0, ret.lastIndexOf('&'));
     return ret;
  }
];

// 添加请求拦截器
$http.interceptors.request.use(function (config) {
  const shid = localStorage.getItem('shid');
  if (!config.data) {
    config.data = {};
  }
  if (shid) {
    config.data.shid = shid;
  }
  const user_token = localStorage.getItem('user_token');
  if (user_token) {
    config.data.user_token = user_token;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

export default $http;